import React, { useState, useEffect } from "react"
import { useLocation } from "react-router-dom"
import "./allBooking.css"
import axios from "axios"
import {
  Card,
  CardBody,
  Col,
  Row,
  Container,
  Label,
  Badge,
} from "reactstrap"
import Breadcrumbs from "../../components/Common/Breadcrumb"
import { AvForm } from "availity-reactstrap-validation"
import ToolkitProvider, {
  Search,
} from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit"
import BootstrapTable from "react-bootstrap-table-next"
import filterFactory, { selectFilter } from "react-bootstrap-table2-filter"
import Loader from "../../helpers/Loader"
import { connect } from "react-redux"
import withRouter from "../../components/Common/withRouter"
import { withTranslation } from "react-i18next"
import moment from "moment"
import BackgroundImage from "../../assets/images/Background.png"
import showNotification from "../../helpers/show_notificaton"
import { postSubmitForm } from "../../helpers/backend_helper"
import CheckoutModal from "./CheckoutModal/index"

const CheckOut = props => {
  const { SearchBar } = Search

  const [bookings, setBookings] = useState([])
  const [bookingsFilter, setBookingsFilter] = useState([])

  const [selectedBooking, setSelectedBooking] = useState(null)
  const [checkoutDetailsModal, setCheckoutDetailsModal] = useState(false)

  const [selectedTable, setSelectedTable] = useState("All")
  const [selectedGame, setSelectedGame] = useState("All")
  const [inprocessTables, setInprocessTables] = useState()

  const location = useLocation()
  const bookingFromNav = location.state?.booking
  const add = JSON.parse(localStorage.getItem("instantcheckout"))

  useEffect(() => {
    fetchBookings()
  }, [])

  useEffect(() => {
    if (selectedGame !== "") {
      loadInProcessTables()
    }
  }, [selectedGame])

  useEffect(() => {
    if (bookingFromNav) {
      openCheckoutDetailsModal(bookingFromNav)
    }
  }, [bookingFromNav])

  useEffect(() => {
    if (add) {
      openCheckoutDetailsModal(add)
      localStorage.removeItem("instantcheckout")
    }
  }, [add])

  const loadInProcessTables = async () => {
    setInprocessTables([])
    let payload = {
      game_name: selectedGame && selectedGame,
    }
    let url = process.env.REACT_APP_BASEURL + "sales/inprocess_game_tables"
    let response = await postSubmitForm(url, payload)
    if (response.status === 1) {
      let res = [new Set(response.data)]
      console.log(res);
      console.log(response.data);
      
      setInprocessTables(response.data)
    } else {
      showNotification(response.message, "Error")
    }
  }

  const fetchBookings = async () => {
    try {
      Loader(true)
      const response = await axios.post(
        process.env.REACT_APP_BASEURL + "bookings/get_in_process",
        {},
        {
          headers: {
            Authorization: `Bearer ${localStorage.getItem("userToken")}`,
          },
        }
      )
      if (response.data.status === 1) {
        Loader(false)
        const filterData = response.data.data.filter(
          inprocess =>
            inprocess?.is_item_only === false &&
            inprocess?.is_package_only === false
        )
        setBookings(filterData)
        setBookingsFilter(filterData)
      } else {
        Loader(false)
      }
    } catch (error) {
      Loader(false)
    }
  }

  const fetchUpdatedData = async row => {
    try {
      let url = process.env.REACT_APP_BASEURL + "bookings/get_in_process"
      const response = await postSubmitForm(url, {})
      if (response.status === 1) {
        const filterData = response.data.filter(
          inprocess =>
            inprocess?.is_item_only === false &&
            inprocess?.is_package_only === false
        )
        setBookings(filterData)
        const updatedRow = filterData?.find(bkg => row._id === bkg?._id)
        if (updatedRow) {
          openCheckoutDetailsModal(updatedRow)
        }
      }
    } catch (error) {
      showNotification(error.message, "Error")
    }
  }

  const openCheckoutDetailsModal = row => {
    setSelectedBooking(row)
    setCheckoutDetailsModal(true)
  }

  const closeCheckoutDetailsModal = () => {
    setSelectedBooking(null)
    setCheckoutDetailsModal(false)
  }

  const onCheckoutSuccess = () => {
    closeCheckoutDetailsModal()
    fetchBookings()
  }

  const columns = [
    {
      dataField: "_id",
      hidden: true,
    },
    {
      text: "S.N.",
      formatter: (cell, row, rowIndex) => {
        const rowNumber = rowIndex + 1
        return rowNumber
      },
      headerStyle: (colum, colIndex) => {
        return { width: "3%" }
      },
    },
    {
      text: "Customer Name",
      dataField: "customer_details.name",
      sort: false,
      headerStyle: (colum, colIndex) => {
        return { width: "5%" }
      },
    },
    {
      text: "Check-In",
      dataField: "check_in",
      formatter: (cell, row) => {
        if (row.check_in) {
          return moment(row.check_in).format("YYYY-MM-DD HH:mm:ss")
        } else {
          return "Not yet checked in "
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "3%" }
      },
    },
    {
      text: props.t("Games"),
      dataField: "game_details",
      formatter: (gameDetails, row) => {
        if (gameDetails && gameDetails.length > 0) {
          return gameDetails.map((game, id) => (
            <Badge key={id} color="primary" className="me-1">
              {game.game.name}
            </Badge>
          ))
        }
        return (
          <Badge style={{ cursor: "not-allowed" }} color="secondary">
            No Games
          </Badge>
        )
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "5%" }
      },
    },
    {
      text: props.t("Tables"),
      dataField: "game_details",
      formatter: (gameDetails, row) => {
        if (gameDetails && gameDetails.length > 0) {
          return gameDetails.map((game, id) => (
            <Badge key={id} color="primary" className="me-1">
              {game.table_number}
            </Badge>
          ))
        }
        return (
          <Badge style={{ cursor: "not-allowed" }} color="secondary">
            No Tables
          </Badge>
        )
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" }
      },
    },
    {
      text: "Duration",
      formatter: (cell, row) => {
        const checkIn = moment(row.check_in)
        const endTime = moment(row.end_time)
        if (checkIn.isValid() && endTime.isValid()) {
          const duration = moment.duration(endTime.diff(checkIn))
          const hours = duration.hours()
          const minutes = duration.minutes()

          if (hours > 0) {
            return hours + " hours " + minutes + " minutes"
          } else if (minutes > 0) {
            return minutes + " minutes"
          } else {
            return "N/A"
          }
        } else {
          return "N/A"
        }
      },
      hidden: false,
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "2%" }
      },
    },
    {
      text: "Check Out",
      dataField: "check_out",
      formatter: (cell, row) => {
        if (row.check_out) {
          return moment(row.check_out).format("YYYY-MM-DD HH:mm:ss")
        } else {
          return "Not yet checked out "
        }
      },
      sort: true,
      headerStyle: (colum, colIndex) => {
        return { width: "3%" }
      },
    },
    {
      text: props.t("Status"),
      dataField: "booking_status",
      filter: selectFilter({
        options: [
          { value: "In Process", label: "In Process" },
          { value: "Unpaid", label: "Unpaid" },
        ],
        defaultValue: "In Process",
        placeholder: "All",
      }),
      style: (cell, row) => {
        return {
          textAlign: "center",
        }
      },
      formatter: (cell, row) => {
        if (row.booking_status === "In Process") {
          return <Badge color="warning">{row.booking_status}</Badge>
        } else if (row.booking_status === "Unpaid") {
          return <Badge color="danger">{row.booking_status}</Badge>
        }
      },
      headerStyle: (colum, colIndex) => {
        return { width: "5%" }
      },
    },
    {
      text: "Game Total Price",
      dataField: "game_total_price",
      sort: false,
      hidden: true,
      formatter: (cell, row) => cell || "0",
      headerStyle: (colum, colIndex) => {
        return { width: "8%" }
      },
    },
    {
      text: "Item Total Price",
      dataField: "item_total_price",
      sort: false,
      hidden: true,
      formatter: (cell, row) => cell || "0",
      headerStyle: (colum, colIndex) => {
        return { width: "8%" }
      },
    },
    {
      text: "Grand Total Price",
      dataField: "total_price",
      sort: false,
      style: (cell, row) => {
        return {
          textAlign: "center",
        }
      },
     formatter: (cell, row) => {      
        if (row.customer_details?.customer_type === "VIP") {
          return "0";
        }
        return cell ? Math.round(cell) : "0";
      },
      headerStyle: (colum, colIndex) => {
        return { width: "6%" }
      },
    },
    {
      dataField: "",
      text: props.t("Check Out"),
      formatter: (cell, row) => (
        <div
          style={{
            display: "flex",
            justifyContent: "center",
            alignItems: "center",
            gap: "15px",
          }}
        >
          {row.booking_status && (
            <div
              style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <i
                className="fa fa-shopping-cart"
                style={{
                  color: "blue",
                  fontSize: "17px",
                  cursor: "pointer",
                  marginTop: "4.3px",
                  marginRight: "5px",
                }}
                onClick={() => {
                  fetchUpdatedData(row)
                }}
              ></i>
            </div>
          )}
        </div>
      ),
      sort: false,
      hidden: false,
      headerStyle: (colum, colIndex) => {
        return { width: "3%" }
      },
    },
  ]

  const filterBookingsByTable = table => {
    if (table === "All") {
      setBookingsFilter(bookings)
    } else {
      const filtered = bookings.filter(booking =>
        booking.game_details.some(game => game.table_number === table)
      )
      setBookingsFilter(filtered)
    }
  }

  useEffect(() => {
    filterBookingsByTable(selectedTable)
  }, [selectedTable])

  const gameNameSet = new Set()
  bookings.forEach(booking => {
    booking.game_details.forEach(game => {
      gameNameSet.add(game.game.name)
    })
  })

  const gameNames = Array.from(gameNameSet).sort((a, b) =>
    a.toLowerCase().localeCompare(b)
  )

  const filterBookingsByGameName = gameName => {
    if (gameName === "All") {
      setBookingsFilter(bookings)
    } else {
      const filtered = bookings.filter(booking =>
        booking.game_details.some(game => game.game.name === gameName)
      )
      setBookingsFilter(filtered)
    }
  }

  useEffect(() => {
    filterBookingsByGameName(selectedGame)
  }, [selectedGame])

  const backgroundImageStyle = {
    backgroundImage: `url(${BackgroundImage})`,
    backgroundSize: "cover",
    backgroundPosition: "center",
  }

  return (
    <React.Fragment>
      <div className="page-content" style={backgroundImageStyle}>
        <Container fluid>
          <Breadcrumbs
            title="Bookings"
            alternateTitle="Check Out"
            breadcrumbItem1="Check Out"
          />

          <Row>
            <Col>
              <Card>
                <CardBody
                  style={{
                    boxShadow: "rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
                  }}
                >
                  <ToolkitProvider
                    keyField="_id"
                    columns={columns}
                    data={bookingsFilter || []}
                    search
                  >
                    {propst => (
                      <div>
                        <AvForm>
                          <Row>
                            <label className="form-label">
                              {"Search In Check Out"}
                            </label>
                            <Col lg={2} md={2} sm={2}>
                              <SearchBar {...propst.searchProps} />
                            </Col>
                            <Col lg={6} md={6} sm={6}></Col>
                            <Col lg={2} md={2} sm={2} style={{ marginTop: "-35px" }}>
                              <Label>{props.t("Game")}</Label>
                              <select
                                name="status"
                                className="form-control"
                                value={selectedGame}
                                placeholder="--Select Table--"
                                onChange={e => {
                                  setSelectedGame(e.target.value)
                                }}
                              >
                                <option value="All">All</option>
                                {gameNames.map(games => (
                                  <option key={games} value={games}>
                                    {games}
                                  </option>
                                ))}
                              </select>
                            </Col>
                            <Col lg={2} md={2} sm={2} style={{ marginTop: "-35px" }}>
                              <Label>{props.t("Game Tables")}</Label>
                              <select
                                name="status"
                                className="form-control"
                                value={selectedTable}
                                placeholder="--Select Table--"
                                onChange={e => {
                                  setSelectedTable(e.target.value)
                                }}
                              >
                                <option value="All">All</option>
                                {inprocessTables?.map(tableNumber => (
                                  <option key={tableNumber} value={tableNumber}>
                                    {tableNumber}
                                  </option>
                                ))}
                              </select>
                            </Col>
                          </Row>
                        </AvForm>
                        <BootstrapTable
                          {...propst.baseProps}
                          filter={filterFactory()}
                          noDataIndication={props.t("No data to display.")}
                          striped
                          condensed
                        />
                      </div>
                    )}
                  </ToolkitProvider>
                </CardBody>
              </Card>
            </Col>
          </Row>
          {selectedBooking && (
            <CheckoutModal
              isOpen={checkoutDetailsModal}
              toggle={closeCheckoutDetailsModal}
              booking={selectedBooking}
              onSuccess={onCheckoutSuccess}
            />
          )}
        </Container>
      </div>
    </React.Fragment>
  )
}

const mapStateToProps = state => ({})

export default connect(mapStateToProps)(withRouter(withTranslation()(CheckOut)))